import { lazy } from "react";

export const AdminDoctorDetailsAsync = lazy(
  () => import("./AdminDoctorDetails")
);
